import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex h-full flex-col gap-3"
};
const _hoisted_2 = {
  class: "rounded-lg border border-slate-200 bg-white p-3"
};
const _hoisted_3 = {
  class: "flex flex-wrap items-center justify-between gap-3"
};
const _hoisted_4 = {
  class: "min-w-0"
};
const _hoisted_5 = {
  class: "mt-0.5 text-xs text-slate-500"
};
const _hoisted_6 = {
  key: 0,
  class: "ml-2 text-red-600"
};
const _hoisted_7 = {
  key: 1,
  class: "ml-2 text-amber-600"
};
const _hoisted_8 = {
  class: "flex w-full flex-wrap gap-2 sm:w-auto sm:justify-end"
};
const _hoisted_9 = ["disabled"];
const _hoisted_10 = ["disabled"];
const _hoisted_11 = ["disabled"];
const _hoisted_12 = ["disabled", "title"];
const _hoisted_13 = {
  key: 0,
  class: "rounded-lg border border-slate-200 bg-white p-3"
};
const _hoisted_14 = {
  class: "flex flex-wrap items-end gap-3"
};
const _hoisted_15 = {
  class: "min-w-0 w-full sm:min-w-[260px] flex-1"
};
const _hoisted_16 = ["value"];
const _hoisted_17 = ["disabled"];
const _hoisted_18 = ["disabled"];
const _hoisted_19 = {
  key: 0,
  class: "mt-3 border-t border-slate-100 pt-3"
};
const _hoisted_20 = {
  class: "mb-2 flex flex-wrap items-center justify-between gap-2"
};
const _hoisted_21 = {
  class: "text-xs text-slate-500"
};
const _hoisted_22 = {
  class: "font-semibold text-slate-900"
};
const _hoisted_23 = {
  key: 0,
  class: "rounded-md border border-dashed border-slate-200 bg-slate-50 px-3 py-4 text-center text-sm text-slate-500"
};
const _hoisted_24 = {
  key: 1,
  class: "grid gap-2 xl:grid-cols-2"
};
const _hoisted_25 = {
  class: "mb-2 flex items-center justify-between gap-2"
};
const _hoisted_26 = {
  class: "min-w-0"
};
const _hoisted_27 = {
  class: "text-sm font-semibold text-slate-900"
};
const _hoisted_28 = {
  class: "ml-2 text-xs text-slate-500"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = {
  class: "grid gap-2 md:grid-cols-3"
};
const _hoisted_31 = {
  class: "mb-1 flex items-center justify-between gap-2"
};
const _hoisted_32 = {
  key: 0,
  class: "text-xs font-medium text-slate-500"
};
const _hoisted_33 = ["title"];
const _hoisted_34 = {
  class: "mt-1 truncate text-xs text-slate-500"
};
const _hoisted_35 = {
  key: 1,
  class: "data-table-empty bg-white"
};
const _hoisted_36 = ["disabled"];
const _hoisted_37 = ["data-chain-id"];
const _hoisted_38 = {
  class: "mb-2 flex flex-wrap items-center gap-2"
};
const _hoisted_39 = {
  class: "invoice-chain-actions-left flex shrink-0 items-center gap-1.5"
};
const _hoisted_40 = {
  class: "mr-1 text-sm font-semibold text-slate-900"
};
const _hoisted_41 = ["disabled", "onClick"];
const _hoisted_42 = ["title", "aria-label", "disabled", "onClick"];
const _hoisted_43 = {
  class: "flex flex-wrap items-baseline gap-2"
};
const _hoisted_44 = {
  class: "text-xs text-slate-500"
};
const _hoisted_45 = {
  key: 0,
  class: "status-badge is-success"
};
const _hoisted_46 = {
  class: "invoice-chain-tree-root flex w-max flex-col gap-2"
};
import { computed, defineComponent, h, nextTick, watch } from 'vue';
import { ArrowDownTrayIcon, ArrowPathIcon, BoltIcon, LockClosedIcon, LockOpenIcon, MagnifyingGlassIcon, MapPinIcon, PlusCircleIcon } from '@heroicons/vue/24/outline';
import { canGenerateChains, formatInvoiceAmount, hasLockedNodeField, issueMarkByKey, issueMarkFor, isPlatformNode, nonPlatformSubjects, regionNameById, sortChainNodes } from '../utils';
import { buildChainTree, chainHasUserSpecifiedEdge, edgeSourceLabel, edgeSourceTone } from '../downstreamRules.mjs';
import InvoiceChainMatrixCell from './InvoiceChainMatrixCell.vue';
import { useWheelToHorizontalScroll } from '../composables/useWheelToHorizontalScroll';
export default {
  __name: 'InvoiceChainWorkspace',
  props: {
    plan: {
      type: Object,
      default: null
    },
    chains: {
      type: Array,
      default: () => []
    },
    customers: {
      type: Array,
      default: () => []
    },
    regions: {
      type: Array,
      default: () => []
    },
    validationIssues: {
      type: Array,
      default: () => []
    },
    syncing: {
      type: Boolean,
      default: false
    },
    exporting: {
      type: Boolean,
      default: false
    },
    focusChainId: {
      type: [Number, String, null],
      default: null
    },
    companyRelationKeyword: {
      type: String,
      default: ''
    },
    companyRelationResult: {
      type: Object,
      default: null
    },
    companyRelationLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:companyRelationKeyword', 'generate', 'export-chains', 'regenerate-unlocked', 'generate-unfilled', 'edit-node', 'lock-chain', 'lock-node', 'regenerate-chain', 'regenerate-after-node', 'search-company-relation', 'clear-company-relation', 'locate-company-relation', 'validate'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const treeScrollRef = useWheelToHorizontalScroll();
    const canGenerate = computed(() => canGenerateChains(props.plan));
    const issueMarkMap = computed(() => issueMarkByKey(props.validationIssues));
    const nonPlatformTotal = computed(() => props.chains.reduce((total, chain) => total + nonPlatformSubjects(chain).length, 0));
    const errorCount = computed(() => props.validationIssues.filter(issue => String(issue?.severity || '').toUpperCase() === 'ERROR').length);
    const productNameWarningCount = computed(() => props.validationIssues.filter(issue => issue?.ruleCode === 'R_PRODUCT_NAME_NOT_MATCHED').length);
    const companyRelationMatches = computed(() => props.companyRelationResult?.matches || []);
    const TreeNode = defineComponent({
      name: 'InvoiceChainTreeNode',
      props: {
        entry: {
          type: Object,
          required: true
        },
        chain: {
          type: Object,
          required: true
        },
        regions: {
          type: Array,
          default: () => []
        },
        issueMarkMap: {
          type: Object,
          default: null
        },
        syncing: {
          type: Boolean,
          default: false
        },
        hasSpecifiedEdge: {
          type: Boolean,
          default: false
        },
        depth: {
          type: Number,
          default: 0
        }
      },
      emits: ['edit-node', 'lock-node', 'regenerate-after-node'],
      setup(componentProps, {
        emit: componentEmit
      }) {
        const regionMap = computed(() => regionNameById(componentProps.regions));
        function nodeRegionName(node) {
          if (!node || node.regionBucketId == null) return '';
          return regionMap.value.get(String(node.regionBucketId)) || '';
        }
        function edgeItems(edge) {
          if (!edge) return [];
          return edge.productItems || edge.edgeProductItems || [];
        }
        function edgeProductName(edge) {
          return edge?.productName || '';
        }
        function edgeProductMatched(edge) {
          if (!edge) return true;
          return edge.productNameMatched === false ? false : true;
        }
        function canRerankAfter(node) {
          if (!node || isPlatformNode(node) || componentProps.hasSpecifiedEdge) return false;
          const subjects = nonPlatformSubjects(componentProps.chain);
          if (subjects.length === 0) return false;
          const last = subjects[subjects.length - 1];
          return last.id !== node.id;
        }
        function onToggleLock(node, fieldKey) {
          const locks = {
            companyLocked: Boolean(node.companyLocked),
            inputAmountLocked: Boolean(node.inputAmountLocked),
            outputAmountLocked: Boolean(node.outputAmountLocked),
            profitRateLocked: Boolean(node.profitRateLocked),
            productNameLocked: Boolean(node.productNameLocked)
          };
          locks[fieldKey] = !locks[fieldKey];
          componentEmit('lock-node', {
            chain: componentProps.chain,
            node,
            locks
          });
        }
        return () => {
          const entry = componentProps.entry;
          const node = entry.node;
          const incomingEdge = entry.incomingEdge;
          const edgeSource = incomingEdge?.edgeSource || 'AUTO';
          const sourceTone = edgeSourceTone(edgeSource);
          const badgeClass = {
            emerald: 'status-badge is-success',
            indigo: 'status-badge is-indigo',
            slate: 'status-badge is-neutral'
          }[sourceTone] || 'status-badge is-neutral';
          const edgeSummary = incomingEdge ? h('div', {
            class: 'mb-0.5 flex min-h-[20px] flex-wrap items-center gap-1.5 text-xs text-slate-500'
          }, [h('span', {
            class: ['status-badge', badgeClass]
          }, edgeSourceLabel(edgeSource)), h('span', {
            class: 'font-medium text-slate-700'
          }, formatInvoiceAmount(incomingEdge.invoiceAmount)), incomingEdge.productName ? h('span', {
            class: incomingEdge.productNameMatched === false ? 'text-amber-700' : 'text-slate-500'
          }, incomingEdge.productName) : null]) : null;
          const nodeCard = h('div', {
            class: 'w-[248px] shrink-0'
          }, [edgeSummary, h(InvoiceChainMatrixCell, {
            node,
            regionName: nodeRegionName(node),
            issueMark: issueMarkFor(componentProps.issueMarkMap, componentProps.chain.id, node),
            edgeProductName: edgeProductName(incomingEdge),
            edgeProductMatched: edgeProductMatched(incomingEdge),
            edgeProductItems: edgeItems(incomingEdge),
            syncing: componentProps.syncing,
            isPlatform: isPlatformNode(node),
            canRerankAfter: canRerankAfter(node),
            onEdit: () => componentEmit('edit-node', {
              chain: componentProps.chain,
              node
            }),
            onToggleLock: fieldKey => onToggleLock(node, fieldKey),
            onRegenerateAfter: () => componentEmit('regenerate-after-node', {
              chain: componentProps.chain,
              node
            })
          })]);
          const childStack = entry.children?.length ? h('div', {
            class: 'flex flex-col gap-2'
          }, entry.children.map(child => h(TreeNode, {
            key: child.node?.id || child.node?.planCustomerId,
            entry: child,
            chain: componentProps.chain,
            regions: componentProps.regions,
            issueMarkMap: componentProps.issueMarkMap,
            syncing: componentProps.syncing,
            hasSpecifiedEdge: componentProps.hasSpecifiedEdge,
            depth: componentProps.depth + 1,
            onEditNode: payload => componentEmit('edit-node', payload),
            onLockNode: payload => componentEmit('lock-node', payload),
            onRegenerateAfterNode: payload => componentEmit('regenerate-after-node', payload)
          }))) : null;
          return h('div', {
            class: 'invoice-chain-tree-node inline-flex items-start gap-1.5'
          }, [nodeCard, childStack ? h('div', {
            class: 'invoice-chain-connector mt-14 flex w-6 shrink-0 justify-center text-sm leading-none text-slate-300'
          }, '→') : null, childStack]);
        };
      }
    });
    function chainNodes(chain) {
      return sortChainNodes(chain?.nodes || chain?.chainNodes || []);
    }
    function nonPlatformCount(chain) {
      return nonPlatformSubjects(chain).length;
    }
    function treeOf(chain) {
      return buildChainTree(chain);
    }
    function chainHasSpecified(chain) {
      return chainHasUserSpecifiedEdge(chain);
    }
    function chainHasLockedNode(chain) {
      return chainNodes(chain).some(node => hasLockedNodeField(node));
    }
    function isFocusChain(chain) {
      return props.focusChainId != null && String(chain.id) === String(props.focusChainId);
    }
    function submitCompanyRelationSearch() {
      emit('search-company-relation', props.companyRelationKeyword);
    }
    function clearCompanyRelationSearch() {
      emit('clear-company-relation');
    }
    function companyRelationMatchKey(match, index) {
      return [match?.chain?.id, match?.targetNode?.id, match?.targetNode?.planCustomerId, index].filter(value => value !== null && value !== undefined && value !== '').join(':');
    }
    function companyRelationChainNo(match, index) {
      return match?.chain?.chainNo || index + 1;
    }
    function companyRelationNodeCount(match) {
      return (match?.nodes || companyRelationSegments(match).map(item => item.node).filter(Boolean)).length;
    }
    function companyRelationSegments(match) {
      return [{
        role: 'upstream',
        label: '上游',
        node: match?.upstreamNode || null,
        edge: match?.upstreamEdge || null,
        badgeClass: 'status-badge is-neutral'
      }, {
        role: 'self',
        label: '自身',
        node: match?.targetNode || null,
        edge: null,
        badgeClass: 'status-badge is-info'
      }, {
        role: 'downstream',
        label: '下游',
        node: match?.downstreamNode || null,
        edge: match?.downstreamEdge || null,
        badgeClass: 'status-badge is-success'
      }];
    }
    function companyRelationNodeName(node) {
      if (!node) return '-';
      return node.effectiveCompanyName || node.manualCompanyName || node.systemCompanyName || node.companyNameSnapshot || node.companyName || '-';
    }
    watch(() => props.focusChainId, id => {
      if (id == null) return;
      nextTick(() => {
        const el = document.querySelector(`article[data-chain-id="${id}"]`);
        if (el && el.scrollIntoView) el.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        });
      });
    });
    return (_ctx, _cache) => {
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[9] || (_cache[9] = _createElementVNode("h3", {
        class: "text-sm font-semibold text-slate-900"
      }, "链路树", -1)), _createElementVNode("p", _hoisted_5, [_createTextVNode(_toDisplayString(__props.plan?.planMonth || '-') + " · " + _toDisplayString(__props.chains.length) + " 条链路 · " + _toDisplayString(nonPlatformTotal.value) + " 个非平台主体 ", 1), errorCount.value > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_6, "· " + _toDisplayString(errorCount.value) + " 个 ERROR", 1)) : _createCommentVNode("", true), productNameWarningCount.value > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_7, "· " + _toDisplayString(productNameWarningCount.value) + " 个品名未匹配", 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_8, [_withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        class: "btn-secondary inline-flex items-center gap-1.5",
        disabled: __props.syncing || __props.exporting || __props.chains.length === 0,
        onClick: _cache[0] || (_cache[0] = $event => emit('export-chains'))
      }, [_createVNode(_unref(ArrowDownTrayIcon), {
        class: "h-4 w-4"
      }), _createTextVNode(" " + _toDisplayString(__props.exporting ? '导出中...' : '导出 Excel'), 1)], 8, _hoisted_9)), [[_directive_permission, 'enterprise-invoice:chain:export']]), _withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        class: "btn-secondary inline-flex items-center gap-1.5",
        disabled: __props.syncing,
        onClick: _cache[1] || (_cache[1] = $event => emit('regenerate-unlocked'))
      }, [_createVNode(_unref(ArrowPathIcon), {
        class: "h-4 w-4"
      }), _cache[10] || (_cache[10] = _createTextVNode(" 重排未锁定 ", -1))], 8, _hoisted_10)), [[_directive_permission, 'enterprise-invoice:chain:generate']]), _withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        class: "btn-secondary inline-flex items-center gap-1.5",
        disabled: __props.syncing,
        onClick: _cache[2] || (_cache[2] = $event => emit('generate-unfilled'))
      }, [_createVNode(_unref(PlusCircleIcon), {
        class: "h-4 w-4"
      }), _cache[11] || (_cache[11] = _createTextVNode(" 补齐未生成 ", -1))], 8, _hoisted_11)), [[_directive_permission, 'enterprise-invoice:chain:generate']]), _withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        class: "btn-primary inline-flex items-center gap-1.5",
        disabled: __props.syncing || !canGenerate.value,
        title: canGenerate.value ? '生成链路' : '请先确认名单后再生成链路',
        onClick: _cache[3] || (_cache[3] = $event => emit('generate'))
      }, [_createVNode(_unref(BoltIcon), {
        class: "h-4 w-4"
      }), _cache[12] || (_cache[12] = _createTextVNode(" 生成链路 ", -1))], 8, _hoisted_12)), [[_directive_permission, 'enterprise-invoice:chain:generate']])])])]), __props.chains.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_cache[13] || (_cache[13] = _createElementVNode("label", {
        class: "mb-1 block text-xs font-medium text-slate-600"
      }, "公司上下游", -1)), _createElementVNode("input", {
        value: __props.companyRelationKeyword,
        type: "search",
        class: "form-search-input form-control-sm w-full",
        placeholder: "输入公司名称查询直接上下游",
        onInput: _cache[4] || (_cache[4] = event => emit('update:companyRelationKeyword', event.target.value)),
        onKeyup: _withKeys(submitCompanyRelationSearch, ["enter"])
      }, null, 40, _hoisted_16)]), _createElementVNode("button", {
        type: "button",
        class: "btn-secondary inline-flex w-full items-center justify-center gap-1.5 sm:w-auto",
        disabled: __props.syncing || __props.companyRelationLoading,
        onClick: submitCompanyRelationSearch
      }, [_createVNode(_unref(MagnifyingGlassIcon), {
        class: "h-4 w-4"
      }), _createTextVNode(" " + _toDisplayString(__props.companyRelationLoading ? '搜索中...' : '搜索'), 1)], 8, _hoisted_17), __props.companyRelationResult ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "btn-secondary w-full sm:w-auto",
        disabled: __props.companyRelationLoading,
        onClick: clearCompanyRelationSearch
      }, " 清空 ", 8, _hoisted_18)) : _createCommentVNode("", true)]), __props.companyRelationResult ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("p", _hoisted_21, [_createTextVNode(" “" + _toDisplayString(__props.companyRelationResult.companyName || __props.companyRelationKeyword) + "” 命中 ", 1), _createElementVNode("span", _hoisted_22, _toDisplayString(companyRelationMatches.value.length), 1), _cache[14] || (_cache[14] = _createTextVNode(" 条链路，每条展示直接上游、自身、直接下游 ", -1))])]), companyRelationMatches.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 未查询到相关链路 ")) : (_openBlock(), _createElementBlock("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyRelationMatches.value, (match, matchIndex) => {
        return _openBlock(), _createElementBlock("article", {
          key: companyRelationMatchKey(match, matchIndex),
          class: "rounded-lg border border-slate-200 bg-slate-50 p-2.5"
        }, [_createElementVNode("header", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, "链路 " + _toDisplayString(companyRelationChainNo(match, matchIndex)), 1), _createElementVNode("span", _hoisted_28, _toDisplayString(companyRelationNodeCount(match)) + " 个节点", 1)]), _createElementVNode("button", {
          type: "button",
          class: "table-action-button is-primary",
          title: "定位链路",
          "aria-label": "定位链路",
          onClick: $event => emit('locate-company-relation', match)
        }, [_createVNode(_unref(MapPinIcon), {
          class: "h-4 w-4"
        })], 8, _hoisted_29)]), _createElementVNode("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyRelationSegments(match), item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.role,
            class: _normalizeClass(['rounded-md border bg-white p-2', item.role === 'self' ? 'border-blue-200 ring-1 ring-blue-100' : 'border-slate-200'])
          }, [_createElementVNode("div", _hoisted_31, [_createElementVNode("span", {
            class: _normalizeClass(['status-badge', item.badgeClass])
          }, _toDisplayString(item.label), 3), item.edge ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_unref(formatInvoiceAmount)(item.edge.invoiceAmount)), 1)) : _createCommentVNode("", true)]), _createElementVNode("p", {
            class: "truncate text-sm font-semibold text-slate-900",
            title: companyRelationNodeName(item.node)
          }, _toDisplayString(companyRelationNodeName(item.node)), 9, _hoisted_33), _createElementVNode("p", _hoisted_34, _toDisplayString(item.edge?.productName || item.node?.productName || '-'), 1)], 2);
        }), 128))])]);
      }), 128))]))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), __props.chains.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_cache[16] || (_cache[16] = _createElementVNode("p", {
        class: "empty-state-title"
      }, "暂无链路", -1)), _cache[17] || (_cache[17] = _createElementVNode("p", {
        class: "empty-state-desc"
      }, "先确认名单后再生成链路树", -1)), _withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        class: "btn-primary mt-3 inline-flex items-center gap-1.5",
        disabled: __props.syncing || !canGenerate.value,
        onClick: _cache[5] || (_cache[5] = $event => emit('generate'))
      }, [_createVNode(_unref(BoltIcon), {
        class: "h-4 w-4"
      }), _cache[15] || (_cache[15] = _createTextVNode(" 生成链路 ", -1))], 8, _hoisted_36)), [[_directive_permission, 'enterprise-invoice:chain:generate']])])) : (_openBlock(), _createElementBlock("div", {
        key: 2,
        ref_key: "treeScrollRef",
        ref: treeScrollRef,
        class: "flex-1 min-h-0 max-w-full space-y-2 overflow-auto rounded-lg border border-slate-200 bg-slate-50 p-2"
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.chains, (chain, chainIndex) => {
        return _openBlock(), _createElementBlock("article", {
          key: chain.id || chain.chainNo || chainIndex,
          "data-chain-id": chain.id,
          class: _normalizeClass(['w-max min-w-full rounded-lg border bg-white p-2.5', isFocusChain(chain) ? 'border-amber-300 ring-2 ring-amber-100' : 'border-slate-200'])
        }, [_createElementVNode("header", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("span", _hoisted_40, "链路 " + _toDisplayString(chain.chainNo || chainIndex + 1), 1), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "table-action-button is-purple",
          title: "重排本链",
          "aria-label": "重排本链",
          disabled: __props.syncing || chain.manualLocked || chainHasLockedNode(chain) || chainHasSpecified(chain),
          onClick: $event => emit('regenerate-chain', chain)
        }, [_createVNode(_unref(ArrowPathIcon), {
          class: "h-4 w-4"
        })], 8, _hoisted_41)), [[_directive_permission, 'enterprise-invoice:chain:generate']]), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: _normalizeClass(['table-action-button', chain.manualLocked ? 'is-success' : 'is-neutral']),
          title: chain.manualLocked ? '解锁本链' : '锁定本链',
          "aria-label": chain.manualLocked ? '解锁本链' : '锁定本链',
          disabled: __props.syncing,
          onClick: $event => emit('lock-chain', {
            chain,
            locked: !chain.manualLocked
          })
        }, [!chain.manualLocked ? (_openBlock(), _createBlock(_unref(LockClosedIcon), {
          key: 0,
          class: "h-4 w-4"
        })) : (_openBlock(), _createBlock(_unref(LockOpenIcon), {
          key: 1,
          class: "h-4 w-4"
        }))], 10, _hoisted_42)), [[_directive_permission, 'enterprise-invoice:chain:lock']])]), _createElementVNode("div", _hoisted_43, [_createElementVNode("span", _hoisted_44, _toDisplayString(nonPlatformCount(chain)) + " 个主体", 1), chainHasSpecified(chain) ? (_openBlock(), _createElementBlock("span", _hoisted_45, "含指定下游")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_46, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(treeOf(chain), root => {
          return _openBlock(), _createElementBlock("div", {
            key: root.node?.id || root.node?.planCustomerId
          }, [_createVNode(_unref(TreeNode), {
            entry: root,
            chain: chain,
            regions: __props.regions,
            "issue-mark-map": issueMarkMap.value,
            syncing: __props.syncing,
            "has-specified-edge": chainHasSpecified(chain),
            onEditNode: _cache[6] || (_cache[6] = payload => emit('edit-node', payload)),
            onLockNode: _cache[7] || (_cache[7] = payload => emit('lock-node', payload)),
            onRegenerateAfterNode: _cache[8] || (_cache[8] = payload => emit('regenerate-after-node', payload))
          }, null, 8, ["entry", "chain", "regions", "issue-mark-map", "syncing", "has-specified-edge"])]);
        }), 128))])], 10, _hoisted_37);
      }), 128))], 512))]);
    };
  }
};